<div class="px-2">

  <div *ngIf="action" [ngSwitch]="action.type">

    <div *ngSwitchCase="'executeCommand'" class="flex flex-column">

      <label class="mb-2">{{ 'model.device' | transloco }}</label>
      <div *ngIf="!action.args.deviceUuid">
        <button
          (click)="devicesOverlay.toggle($event)"
          [label]="'select.device' | transloco"
          class="mt-2"
          icon="pi pi-mobile"
          pButton
        ></button>
      </div>

      <div *ngIf="action.args.deviceUuid" class="flex flex-column">

        <div (click)="devicesOverlay.toggle($event);" class="custom-input-outline mb-3">
          <p class="mb-0">{{ uuidDeviceMap.get(action.args.deviceUuid) }}</p>
          <i class="pi pi-arrow-right-arrow-left"></i>
        </div>

        <div class="grid">
          <div class="col-12">
            <label>{{ 'attribute.commandsSchema' | transloco }}</label>
            <p-dropdown
              (onChange)="onCommandSchemaChange($event.value)"
              [(ngModel)]="action.args.schema"
              [options]="availableCommandSchemas"
              [placeholder]="'select.commandsSchema' | transloco"
              appendTo="body"
              optionLabel="name"
              optionValue="name"
              styleClass="w-full mt-2"
            ></p-dropdown>
          </div>
          <div class="col-12">
            <label>{{ 'model.command' | transloco }}</label>
            <p-dropdown
              (onChange)="onCommandChange($event.value)"
              [(ngModel)]="action.args.command"
              [disabled]="!selectedCommandSchema"
              [options]="selectedCommandSchema ? (selectedCommandSchema.commands | keyvalue) : []"
              [placeholder]="'select.command' | transloco"
              appendTo="body"
              optionLabel="key"
              optionValue="key"
              styleClass="w-full mt-2"
            ></p-dropdown>
          </div>
          <div class="col-12 flex justify-content-between">
            <p-selectButton
              (ngModelChange)="action.args.askParamsToUser = $event; observeCommandInputs()"
              [ngModel]="action.args.askParamsToUser"
              [options]="paramOptions | translateLabels | async"
              optionLabel="label"
              optionValue="value"
            ></p-selectButton>
          </div>
          <div
            *ngIf="selectedCommandParams && (selectedCommandParams | keyvalue).length > 0"
            class="col-12">
            <ng-container
              *ngIf="action.args.command !== 'sendCommand' && action.args.schema !== 'industrial-gateway-v1'">
              <div *ngFor="let keyValue of selectedCommandParams | keyvalue" class="flex flex-column">
                <label class="mb-2">{{ 'misc.paramLabel' | transloco: {paramName: keyValue.key} }}</label>
                <app-generic-command-input
                  [(value)]="action.args.params[keyValue.key]"
                  [validators]="keyValue.value.validators"
                ></app-generic-command-input>
              </div>
            </ng-container>
            <ng-container
              *ngIf="action.args.command === 'sendCommand' && action.args.schema === 'industrial-gateway-v1'">
              <app-synoptics-industrial-gateway-command-form
                (validFormChange)="industrialFormValidity = $event"
                [(deviceGateway)]="action.args.params['deviceGateway']"
                [(sensorName)]="action.args.params['sensorName']"
                [(sensorValue)]="action.args.params['sensorValue']"
                [deviceUuid]="action.args.deviceUuid"
                [mode]="!action.args.askParamsToUser ? 'sendCommand' : 'form'"
              >
              </app-synoptics-industrial-gateway-command-form>
            </ng-container>
          </div>
        </div>

      </div>

    </div>

    <div *ngSwitchCase="'showPopup'" class="flex flex-column">
      <div
        (click)="componentsOverlay.toggle($event);"
        [style.height]="action.args.component ? '145px' : '33px'"
        class="custom-input-outline mb-3 pl-2 pr-3"
      >
        <div *ngIf="action.args.component" class="flex flex-column">
          <p class="mb-2">{{ 'attribute.component' | transloco }} {{ action.args.component }}</p>
          <app-synoptic-thumbnail
            [alt]="action.args.component"
            [file]=" synopticFiles | find: {name: ( components | find: { name: action.args.component } ).file}"
          >
          </app-synoptic-thumbnail>
        </div>
        <p *ngIf="!action.args.component" class="mb-0 text-gray-600">{{ 'select.component' | transloco }}</p>
        <i class="pi pi-arrow-right-arrow-left"></i>
      </div>
    </div>

    <div *ngSwitchCase="'showTooltip'" class="flex flex-column">
      <div class="w-full my-2 flex gap-3">
        <div class="flex flex-column flex-grow-1">
          <label class="mb-2">{{ 'common.title' | transloco }}</label>
          <input [(ngModel)]="action.args.title" class="w-full" pInputText>
        </div>
        <div class="flex flex-column">
          <label class="mb-2">{{ 'attribute.showDates' | transloco }}</label>
          <p-checkbox
            [(ngModel)]="action.args.showDates"
            [binary]="true"
          ></p-checkbox>
        </div>
      </div>
      <div>
        <button
          (click)="addTooltipRow(action.args.rows)"
          [label]="'misc.addTooltipRow' | transloco"
          class="mt-1"
          icon="pi pi-plus"
          pButton
        ></button>
      </div>
      <div *ngFor="let row of action.args.rows" class="mt-3 flex tooltip-row-card">
        <div class="flex flex-column flex-grow-1 p-3">
          <div class="w-full flex">
            <div class="w-6 pr-2 flex flex-column">
              <label class="mb-2">{{ 'attribute.name' | transloco }}</label>
              <input [(ngModel)]="row.label" class="w-full" pInputText>
            </div>
            <div class="w-6 pl-2 flex flex-column">
              <label class="mb-2">{{ 'attribute.value' | transloco }}</label>
              <button
                (click)="rowBeingModified = row; measurementSensorOverlay.toggle($event);"
                *ngIf="!row.value"
                [label]="'select.sensor' | transloco"
                icon="pi pi-wifi"
                pButton
              ></button>
              <div
                (click)="rowBeingModified = row; measurementSensorOverlay.toggle($event);"
                *ngIf="row.value"
                class="custom-input-outline"
              >
                <p class="mb-0">
                  {{ uuidSensorMap.get(row.value.entityUuid + '/' + (row.value.sensorUuid ?? null)) }}
                </p>
                <button
                  class="ml-2 p-button-icon-only p-button-text"
                  icon="pi pi-arrow-right-arrow-left"
                  pButton
                ></button>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-content-center align-items-center bg-gray-100 p-3">
          <button
            (click)="removeTooltipRow(row, action.args)"
            class="p-button-text p-button-icon-only text-gray-600"
            icon="pi pi-trash"
            pButton
          ></button>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="'linkToSynoptic'" class="flex flex-column">
      <label class="mb-2">{{ 'model.synoptic' | transloco }}</label>
      <p-dropdown
        *ngIf="synoptics"
        [(ngModel)]="action.args.synopticUuid"
        [filter]="true"
        [options]="synoptics"
        appendTo="body"
        filterBy="name"
        optionLabel="name"
        optionValue="uuid"
        styleClass="w-full"
      ></p-dropdown>
    </div>

  </div>

  <div *ngIf="action" class="mt-4 flex justify-content-between">
    <button
      (click)="dynamicDialogRef.close(null)"
      [label]="'common.cancel' | transloco"
      class="p-button-danger"
      pButton
    ></button>
    <button
      (click)="dynamicDialogRef.close(action)"
      [disabled]="this.action.type === 'executeCommand' && !action.args.askParamsToUser  ?
      action.args.schema !== 'industrial-gateway-v1'  ? (!(isFormValid$ | async) ) : !industrialFormValidity
      : !isValid "
      [label]="'common.save' | transloco"
      pButton
    ></button>
  </div>

</div>

<p-overlayPanel #devicesOverlay [showCloseIcon]="true" [style]="{width: '450px'}" appendTo="body">
  <ng-template pTemplate>
    <p-table
      (selectionChange)="applyDeviceToArgs($event.uuid); devicesOverlay.hide();"
      [(first)]="devicesFirst"
      [(rows)]="devicesRows"
      [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
      [paginator]="true"
      [totalRecords]="devices.length"
      [value]="devices"
      selectionMode="single"
      sortField="name"
      styleClass="p-datatable-striped mt-3"
    >
      <ng-template pTemplate="header">
        <tr>
          <th scope="col" class="w-18rem" pSortableColumn="serialNumber">
            {{ 'attribute.serialNumber' | transloco }}
            <p-sortIcon field="serialNumber"></p-sortIcon>
          </th>
          <th scope="col" class="w-18rem" pSortableColumn="alias">
            {{ 'attribute.alias' | transloco }}
            <p-sortIcon field="alias"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template let-device pTemplate="body">
        <tr [pSelectableRow]="device">
          <td>
            <span class="p-column-title bold">{{ 'model.device' | transloco }}</span>
            {{ device.serialNumber }}
          </td>
          <td>
            <span class="p-column-title bold">{{ 'attribute.alias' | transloco }}</span>
            <p class="text-right md:text-left" style="word-break: break-all;">{{ device.alias }}</p>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-overlayPanel>

<p-overlayPanel #componentsOverlay [showCloseIcon]="true" [style]="{width: 'min(450px, 100vw)'}" appendTo="body">
  <ng-template pTemplate>
    <p-table
      (selectionChange)="!$event || (action.args.component = $event.name); componentsOverlay.hide();"
      [(selection)]="selectedComponent"
      [paginator]="true"
      [rows]="5"
      [value]="components"
      responsiveLayout="scroll"
      selectionMode="single"
    >
      <ng-template pTemplate="header">
        <tr>
          <th scope="col" pSortableColumn="name">{{ 'attribute.component' | transloco }}
            <p-sortIcon field="name"></p-sortIcon>
          </th>
          <th scope="col">{{ 'common.image' | transloco }}</th>
        </tr>
      </ng-template>
      <ng-template let-component let-rowData pTemplate="body">
        <tr [pSelectableRow]="rowData">
          <td>{{ component.name }}</td>
          <td>
            <app-synoptic-thumbnail
              [alt]="action.args.file"
              [file]="(synopticFiles | find: { name: component.file })"
            >
            </app-synoptic-thumbnail>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-overlayPanel>

<p-overlayPanel #measurementSensorOverlay [showCloseIcon]="true" [style]="{width: '450px'}">
  <ng-template pTemplate>
    <app-synoptics-form-measurement-selector
      (selectionChange)="rowBeingModified.value = $event; measurementSensorOverlay.hide();"
      [assetMeasurements]="assetMeasurements"
      [deviceMeasurements]="deviceMeasurements"
      [kpis]="kpis"
    ></app-synoptics-form-measurement-selector>
  </ng-template>
</p-overlayPanel>
